import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete an if node and all connected edgee
 * @param context
 * @param reactFlowInstance
 */
export function processIfNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditSwitchNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditSwitchNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);

}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditSwitchNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}


export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        data_store: {
            'type': 'string',
            title: 'Data Input',
            'description': 'Data to be evaluated'
        },
        input_key: {
            'title': 'Data Value Key',
            type: 'string',
            description: 'Value for data model attributes, enter as value_one/value_two',
        },
        conditions: {
            title: 'Conditions',
            description: 'Each condition corresponds to a Node output',
            type: 'array',
            maxItems: 10,
            items: {
                title: '',
                type: 'object',
                properties: {
                    label: {
                        title: "Label",
                        type: 'string',
                    },
                    evaluation: {
                        title: 'Conditional',
                        type: 'string',
                        enum: [
                            'Equal To',
                            'Not Equal To',
                            'Greater Than',
                            'Less Than',
                            'Length Greater Than',
                            'Length Less Than',
                            'Length Equal To',
                            'Is String',
                            'Is Not String',
                            'Is Array',
                            'Is Not Array',
                            'Is Data Model',
                            'Is Not Data Model',
                            'Is Number',
                            'Is Not Number',
                            'Is True',
                            'Is False',
                            'Parsable JSON'
                        ],
                        default: 'Equal To',
                        description: 'The conditional type to evaluate the data input against. Length is for arrays or text'
                    },

                },
                allOf: [
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Length Equal To',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Length Less Than',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Length Greater Than',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Less Than',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Greater Than',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Not Equal To',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Equal To',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            },
                            required: [ 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Length Greater Than',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Length Less Than',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Length Equal To',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Equal To',
                                },
                            }
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Not Equal To',
                                },
                            },
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Greater Than',
                                },
                            },
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    },
                    {
                        if: {
                            properties: {
                                evaluation: {
                                    const: 'Data Model Less Than',
                                },
                            },
                        },
                        then: {
                            properties: {
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                },
                                evaluation_key: {
                                    'title': 'Data Model Key',
                                    type: 'string',
                                    description: 'Value for data model attributes, enter as value_one/value_two',
                                }
                            },
                            required: [ 'evaluation_key', 'evaluation_value' ]
                        }
                    }
                ]
            }
        },
    },
}

export const nodeDescription: string = "This node is a routing node.\n" +
    "Up to 10 conditions can be set. Each condition corresponds to a node output.\n" +
    "If the condition is met, the associated node output is used as the path to the next node.\n";